<template>
  <div class="contenedor-cpanel">
    <!-- <Header2/> -->
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Servicio Impago</h1>
        <div class="barra"></div>
      </div>
      <ServiciosImpagosLista
      ></ServiciosImpagosLista>
    </section>
  </div>
</template>

<script>
import ServiciosImpagosLista from '../components/ServiciosImpagosLista.vue'
export default {
  name: 'ServicioImpago',
  components: {
    ServiciosImpagosLista
  },
  data: function () {
    return {
    }
  }
}
</script>

<style>

</style>
